import React, { useEffect, useRef } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import widgetRender from './bei-light';
import SliderComponent from '../FeedBackSynthesis/Slider';

function test2(data, action) {
  // json parametres de la viz
  const widgetProperties_US342 = {
    generalProperties: {
      chartType: 'barchart', // barchart, pie, linechart
      orientation: 'vertical', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 60, right: 40, bottom: 50, left: 120 },
      size: { width: '100%', height: '100%' },
      minSize: { width: 200, height: 200 },
      minPlotSize: { width: 100, height: 100 },
      activeClipPath: false,
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: false,
      dimensionFields: ['methodology'],
      dimensionFieldsDatatype: ['text'],
      dimensionFieldsLabel: ['methodology'],
      dimensionFieldsFormat: null,
      dimensionFieldsCustomSort: [null],
      dimensionFieldsSortOrder: [null],
      calculationFields: ['min', 'max'],
      calculationFieldsFormula: ['__sum__', '__sum__'],
      calculationFieldsLabel: ['min', 'max'],
      calculationFieldsDatatype: ['number', 'number'],
      calculationFieldsFormat: ['.5', '.5'],
      calculationFieldsAdjustPct: false,
      multiCalculationFields: {
        active: true,
        mode: 'range'
      },
      styles: {
        themeScheme: 'beiLightTheme',
        colors: {
          defaultColor: '#002380',
          defaultStrokeColor: '#002380',
          defaultFillColor: '#002380',
          dimensionField: ['serieIndex'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: null,
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: ['scaleOrdinal'], // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: ['#002380', '#1E91A6', '#75C7C3', '#A3E3C0', '#CFFCD1'],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: ''
        }
      },
      XYChart: {
        includeOrigin: false, // used for barchart / linechart
        linearGridline: true,
        categoricalGridline: false,
        linearAxis: false,
        linearAxisLine: false,
        linearAxisLabel: true,
        linearAxisLabelFormat: '.3s',
        linearAxisTick: false,
        linearAxisMinMaxExtendFactor: [0.9, 1.2],
        linearAxisTicksNumber: 5,
        categoricalAxis: true,
        categoricalAxisLabel: true,
        categoricalAxisTick: false,
        categoricalAxisLabelFormat: null,
        categoricalAxisLabelVPadding: 0,
        categoricalAxisLabelHPadding: 0,
        categoricalAxisLabelTextWrapWidth: 0,
        categoricalAxisLabelTextWrapLineHeight: 1.2,
        categoricalAxisLabelTextAnchor: 'end',
        barPadding: 0.5, // value between 0 and 1
        barRadius: 0, // value in px
        barRadiusPosition: 'all', // all, top, bottom
        barGroupPadding: 0.7, // value between 0 and 1
        barBandwithReduction: 0,
        referenceLines: [
          {
            type: 'line', // line, band, area
            axis: 'linear', // linear, categorical
            values: [1000000],
            valuesShowOnAxis: false,
            color: '#FF4437',
            dashArray: '0',
            width: 2,
            title: {
              text: 'Target',
              color: '#FF4437',
              vPosition: 'top',
              hPosition: 'right',
              hPadding: 0,
              vPadding: -5,
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontWeight: '300',
              textAnchor: 'middle'
            }
          }
        ]
      },
      axis: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '200',
        color: '#979797',
        altColor: '#000000',
        labelColor: '#65676a',
        tickSize: 0,
        padding: 0,
        lineWidth: 0
      },
      gridline: {
        padding: -10,
        showExtend: true,
        dashArray: '10 10',
        width: 0.5,
        color: '#979797',
        altColor: '#000000',
        opacity: 0.8
      },
      title: {
        visible: true,
        text: null,
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '13px',
        fontWeight: '300',
        textAnchor: 'middle',
        SVG:
          "<text style='text-anchor:start'><tspan dy='0.7em'>VALUATION RETAINED</tspan><tspan x='0' dy='1.4em'>BY INVESTORS</tspan></text>"
      },
      label: {
        visible: false
      },
      tooltip: {
        active: true,
        hPosition: 'shape', // shape, mouse, fixe
        vPosition: 'shape',
        hRelPosition: 'center',
        vRelPosition: 'up',
        // 'column' : ['cout','etp_contractuel','etp_ecart'],
        // 'columnSuffix' : [' ETP absence',' ETP contractuel',' ETP par rapport au indirect'],
        lineSeparator: true,
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353', // '#FFFFFF'
        fontSize: '15px',
        fontWeight: '400',
        textAnchor: 'start',
        backgroundColor: '#ffffff', // '#535353',
        SVG:
          "<g><g><line x1='14' x2='14' y1='10' y2='80' style='stroke : #002380;stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan x='25' y='20'>methodology : [methodology]</tspan><tspan x='25' y='55'>Min : [min]</tspan><tspan x='25' y='75'>Max : [max]</tspan></text></g>",
        variableFormat: {
          min: { datatype: 'number', formatIn: '.5', formatOut: '$,.5d' },
          max: { datatype: 'number', formatIn: '.5', formatOut: '$,.5d' }
        },
        tooltipSpecificFn: null
      },
      animation: {
        active: true,
        duration: 600,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeCubic' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: 'ChartValuationRetained',
      dataIn: data,
      dataOut: null,
      d3viz: {
        dom: { viz: null, gridline: null, plot: null, axis: null, title: null },
        axis: {
          x: null,
          y: null,
          x2: null,
          y2: null,
          color: null,
          texture: null
        },
        barchart: { bandwidth: null }
      }
    }
  };

  widgetRender(widgetProperties_US342, action);
}

const ChartValuationRetained = ({ data, loading, error }) => {
  const d3svg = useRef(false);

  /*   useEffect(() => {
    }, [loading]); */

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        test2(data, 'init');
      }
    } else d3svg.current = true;
  }, [data]);

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id="ChartValuationRetained"
        role="img"
        style={{ width: '50%', height: '300px' }}>
        {loading && (
          <h6>
            <LinearProgress />
          </h6>
        )}
        {error && <h4 style={{ color: 'red' }}>{error}</h4>}
      </div>
    </>
  );
};

export default ChartValuationRetained;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
